<template>
  <teleport to="body">
    <transition
      enter-active-class="transition-opacity duration-300 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
      @after-leave="cleanupBodyStyles"
    >
      <div
        v-if="open"
        class="prismic-default-headings prismic-rich-text-default fixed inset-0 z-[60] flex items-center justify-center bg-gray-500/75"
        @click.self="close"
      >
        <div
          class="relative w-full max-w-3xl rounded-lg bg-white p-6 shadow-xl"
        >
          <div class="flex items-center justify-between">
            <div>
              <PrismicHeading v-if="slice.title" :field="slice.title" />
            </div>
            <FontAwesomeIcon
              :icon="{ prefix: 'fas', iconName: 'close' }"
              class="h-6 w-6 cursor-pointer text-gray-400 hover:text-gray-500"
              @click="close"
            />
          </div>
          <div
            class="custom-scrollbar-hidden max-h-[85vh] w-full overflow-y-auto"
          >
            <div class="mt-4">
              <PrismicRichText
                v-if="slice.description"
                :field="slice.description"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { onBeforeUnmount, watch } from 'vue';
import PrismicHeading from '@/components/Prismic/PrismicHeading.vue';

const emit = defineEmits(['update:open']);

const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  open: {
    type: Boolean,
    required: true,
  },
});

const close = () => emit('update:open', false);

onBeforeUnmount(() => {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
});
const cleanupBodyStyles = () => {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
};

watch(
  () => props.open,
  newValue => {
    if (newValue) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }
);
</script>

<style>
.custom-scrollbar-hidden::-webkit-scrollbar {
  width: 8px;
}

.custom-scrollbar-hidden::-webkit-scrollbar-thumb {
  background-color: #b0b0b0;
  border-radius: 4px;
}

.custom-scrollbar-hidden::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar-hidden {
  -ms-overflow-style: none;
}
</style>
